import styled ,{createGlobalStyle} from "styled-components";

const GlobalStyle = createGlobalStyle`
  /* Paleta institucional Radixagro (alineada a RRSS).
     NOTA: los valores hex son tentativos — confirmar con el manual de marca. */
  :root{
    --brand-orange: #f8bb59;   /* naranja cálido */
    --brand-brown:  #5C3A21;   /* marrón profundo */
    --brand-cream:  #e1e4d5;   /* crema */
    --brand-teal:   #18776a;   /* verde azulado (teal) */
    --brand-gold:   #f8bb59;   /* dorado (acento) */

    /* Override de variables de Bootstrap (antes azul por defecto) */
    --bs-primary: var(--brand-teal);
    --bs-secondary: var(--brand-brown);
    --bs-body-font-family: 'Poppins', sans-serif;
  }

  *{
    box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: 'Poppins', sans-serif;
  }
`;

export const Container = styled.div`
	width: 100%;
	max-width: 1300px;
	margin-right: auto;
	margin-left: auto;
	padding: 0 20px;
	
	@media screen and (max-width: 1200px) {
		max-width: 100%;
		padding: 0 30px;
	}
	
	@media screen and (max-width: 768px) {
		padding: 0 20px;
	}
	
	@media screen and (max-width: 480px) {
		padding: 0 15px;
	}
`;
export const MainHeading = styled.h1`
	font-size: clamp(2.3rem, 6vw, 4.5rem);
	margin-bottom: 2rem;
	color: #fff;
	width: 100%;
	letter-spacing: 4px;
	text-align: center;
	
	@media screen and (max-width: 768px) {
		font-size: clamp(2rem, 8vw, 3.5rem);
		letter-spacing: 2px;
		margin-bottom: 1.5rem;
	}
	
	@media screen and (max-width: 480px) {
		font-size: clamp(1.8rem, 10vw, 2.8rem);
		letter-spacing: 1px;
		margin-bottom: 1rem;
	}
`;

export const Heading = styled.h2`
	font-size: clamp(1.3rem, 13vw, 3.1rem);
	margin: ${({ margin }) => (margin ? margin : '')};
	margin-bottom: ${({ mb }) => (mb ? mb : '')};
	margin-top: ${({ mt }) => (mt ? mt : '')};
	color: ${({ inverse }) => (inverse ? '$403ae3' : '#fff')};
	letter-spacing: 0.4rem;
	line-height: 1.06;
	text-align: center;
	width: ${({ width }) => (width ? width : '100%')};
`;
export const TextWrapper = styled.span`
	color: ${({ color }) => (color ? color : '')};
	font-size: ${({ size }) => (size ? size : '')};
	font-weight: ${({ weight }) => (weight ? weight : '')};
	letter-spacing: ${({ spacing }) => (spacing ? spacing : '')};
	padding: ${({ padding }) => (padding ? padding : '')};
	margin: ${({ margin }) => (margin ? margin : '')};
	margin-bottom: ${({ mb }) => (mb ? mb : '')};
	margin-top: ${({ mt }) => (mt ? mt : '')};
`;
export const Section = styled.section`
	padding: ${({ padding }) => (padding ? padding : '80px 0')};
	margin: ${({ margin }) => (margin ? margin : '')};
	background: ${({ inverse }) => (inverse ? '#e1e4d5' : '#066a67' )};
	position: ${({ position }) => (position ? position : '')};
	width: ${({ width }) => (width ? width : 'auto')};
	min-width: ${({ minWidth }) => (minWidth ? minWidth : 'auto')};
	max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : 'auto')};
	height: ${({ height }) => (height ? height : 'auto')};
	max-height: ${({ maxHeight }) => (maxHeight ? maxHeight : 'auto')};
	min-height: ${({ minHeight }) => (minHeight ? minHeight : 'auto')};
	
	@media screen and (max-width: 768px) {
		padding: ${({ smPadding }) => (smPadding ? smPadding : '60px 0')};
		padding-top: ${({ smPadding }) => (smPadding ? smPadding.split(' ')[0] : '160px')}; /* 60px + 100px navbar */
	}
	
	@media screen and (max-width: 480px) {
		padding: ${({ smPadding }) => (smPadding ? smPadding : '40px 0')};
		padding-top: ${({ smPadding }) => (smPadding ? smPadding.split(' ')[0] : '40px')}; /* 40px + 90px navbar */
	}
`;

export const Row = styled.div`
	display: flex;
	justify-content: ${({ justify }) => (justify ? justify : '')};
	align-items: ${({ align }) => (align ? align : '')};
	gap: ${({ gap }) => (gap ? gap : '')};
	padding: ${({ padding }) => (padding ? padding : '')};
	margin: ${({ margin }) => (margin ? margin : '')};
	position: ${({ position }) => (position ? position : '')};
	width: ${({ width }) => (width ? width : 'auto')};
	min-width: ${({ minWidth }) => (minWidth ? minWidth : 'auto')};
	max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : 'auto')};
	height: ${({ height }) => (height ? height : 'auto')};
	max-height: ${({ maxHeight }) => (maxHeight ? maxHeight : 'auto')};
	min-height: ${({ minHeight }) => (minHeight ? minHeight : 'auto')};
	flex-wrap: ${({ wrap }) => (wrap ? wrap : '')};
`;

export const Column = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: ${({ justify }) => (justify ? justify : '')};
	align-items: ${({ align }) => (align ? align : '')};
	gap: ${({ gap }) => (gap ? gap : '')};
	padding: ${({ padding }) => (padding ? padding : '')};
	margin: ${({ margin }) => (margin ? margin : '')};
	position: ${({ position }) => (position ? position : '')};
	width: ${({ width }) => (width ? width : 'auto')};
	min-width: ${({ minWidth }) => (minWidth ? minWidth : 'auto')};
	max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : 'auto')};
	height: ${({ height }) => (height ? height : 'auto')};
	max-height: ${({ maxHeight }) => (maxHeight ? maxHeight : 'auto')};
	min-height: ${({ minHeight }) => (minHeight ? minHeight : 'auto')};
`;

export const Button = styled.button`
	border-radius: 4px;
	background: none;
	white-space: nowrap;
	padding: 12px 24px;
	font-size: 16px;
	color: #fff;
	outline: none;
	border: 2px solid #fff;
	cursor: pointer;
	overflow: hidden;
	position: relative;
	transition: all 0.3s ease;
	min-height: 44px; /* Tamaño mínimo táctil */
	
	&:before {
		background: #fff;
		content: '';
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: -1;
		transition: all 0.6s ease;
		width: 100%;
		height: 0%;
		transform: translate(-50%, -50%) rotate(45deg);
	}
	
	&:hover:before {
		height: 500%;
	}
	
	&:hover {
		color: black;
	}
	
	&:active {
		transform: scale(0.98);
	}
	
	@media screen and (max-width: 768px) {
		padding: 12px 20px;
		font-size: 15px;
		min-height: 48px;
	}
	
	@media screen and (max-width: 480px) {
		padding: 12px 18px;
		font-size: 14px;
		min-height: 50px;
		width: 100%;
		max-width: 280px;
	}
`;

export default GlobalStyle;
